import {Component, HostBinding, Input} from '@angular/core';

@Component({
  selector: 'rx-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss']
})

export class TabComponent {
  /**
   * Tab title
   */
  @Input() title: string;
  /**
   * Tab icon
   */
  @Input() icon: string;
  /**
   * Tab size, possible values: "small"
   */
  @HostBinding('class') @Input() size: string;
  /**
   * Tab selected state
   */
  @HostBinding('class.selected') @Input() selected = false;
}
